import React from 'react';

function MapTrifold(props) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_4432_38278)">
        <path
          d="M19.6728 4.27033C19.5905 4.20616 19.4946 4.16159 19.3924 4.14C19.2903 4.11841 19.1846 4.12037 19.0833 4.14572L13.8299 5.45885L8.55766 2.82228C8.41076 2.74901 8.24249 2.73072 8.08328 2.77072L2.58328 4.14572C2.43455 4.1829 2.30251 4.26872 2.20815 4.38955C2.11379 4.51038 2.06252 4.65929 2.0625 4.8126V17.1876C2.06252 17.2921 2.08634 17.3952 2.13216 17.489C2.17798 17.5829 2.24459 17.6651 2.32694 17.7294C2.40928 17.7937 2.50519 17.8384 2.60739 17.86C2.70958 17.8817 2.81537 17.8798 2.91672 17.8545L8.17008 16.5413L13.4423 19.1779C13.5381 19.2251 13.6433 19.2498 13.75 19.2501C13.8062 19.2501 13.8622 19.2431 13.9167 19.2295L19.4167 17.8545C19.5655 17.8173 19.6975 17.7315 19.7919 17.6106C19.8862 17.4898 19.9375 17.3409 19.9375 17.1876V4.8126C19.9375 4.70803 19.9137 4.60484 19.8678 4.51087C19.822 4.4169 19.7553 4.33464 19.6728 4.27033ZM8.25 15.1251C8.19379 15.1251 8.1378 15.1321 8.08328 15.1457L3.4375 16.3067V5.34971L8.17008 4.16635L8.25 4.20588V15.1251ZM18.5625 16.6505L13.8299 17.8338L13.75 17.7943V6.8751C13.8062 6.87534 13.8622 6.8687 13.9167 6.85533L18.5625 5.69346V16.6505Z"
          fill="#65ADFF"
        />
      </g>
    </svg>
  );
}

export default MapTrifold;
